import { fetchHelper } from './api'
import { profileActions } from '../redux/profileSlice'

export const updateUser = userDetails => async dispatch => {
    dispatch(profileActions.updateProfileRequest())
    try {
        if (userDetails.profilepicture) {
            //Upload new dp
            const formData = new FormData()
            formData.append('file', userDetails.profilepicture)
            const dpRes = await fetchHelper.post(
                `Customer/UploadDp/${userDetails.email}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )
            userDetails.profilepicture = dpRes.data
        }

        await fetchHelper.put(`Customer/${userDetails.email}`, userDetails)
        dispatch(profileActions.updateProfileRequestSuccess(userDetails))
    } catch (e) {
        dispatch(profileActions.updateProfileRequestError(e.message))
    }
}
